import { createSelector } from 'reselect';
import { getMetadataFromMetricDetailsWithFilePath } from './Metric/components/Wizard/MetricWizard.utils';
import { DEFAULT_METADATA } from './Metric/components/CreateModal/CreateModal.constants';
export const getWorkspaceIdFromState = (state) => { var _a, _b; return (_b = (_a = state.currentUserDetails.userAffinity) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.workspaceId; };
export const getWorkspaceIdSelector = createSelector([getWorkspaceIdFromState], (workspaceId) => workspaceId);
export const getMetricMetadataSelector = (state) => {
    const metadata = state.maui.draft.metrics.metric_wizard.metadata;
    const metric_details = state.maui.draft.metrics.metric_wizard.metric_details.data;
    return !!metadata
        ? metadata
        : !!metric_details
            ? getMetadataFromMetricDetailsWithFilePath(state.maui.draft.metrics.metric_wizard.metric_details.data)
            : DEFAULT_METADATA;
};
export const getComputationFilePathOptions = (state) => {
    var _a;
    const computationFilePaths = (_a = state.maui.draft.computation_file_paths.data) !== null && _a !== void 0 ? _a : [];
    return computationFilePaths.filter((m) => !m.match(/\.autogen\.xml$/g));
};
export const getCustomColumns = (state) => {
    return state.maui.draft.columns.list;
};
export const getRawColumns = (state) => {
    return state.maui.draft.raw_columns;
};
export const getAggregationLevels = (state) => {
    return state.maui.draft.aggregation_levels;
};

//# sourceMappingURL=Maui.selectors.js.map
